import { Navigate, Route, Routes } from 'react-router-dom'
import { usePortalAuth } from './auth/PortalAuth'
import { Layout } from './components/Layout'
import LoginPage from './pages/LoginPage'
import DashboardPage from './pages/DashboardPage'
import ShipmentsPage from './pages/ShipmentsPage'
import OrdersPage from './pages/OrdersPage'
import InvoicesPage from './pages/InvoicesPage'
import ClaimsPage from './pages/ClaimsPage'
import TrackPage from './pages/TrackPage'
import { ForgotPasswordPage, SetPasswordPage } from './pages/PasswordPages'

export default function App() {
  const { user, loading } = usePortalAuth()

  return (
    <Routes>
      {/*
        Outside the session check on purpose. A consignee following a link from
        a WhatsApp message has no account here and must never be bounced to a
        sign-in form; the token in the URL is the whole authorisation.
      */}
      <Route path="/track/:token" element={<TrackPage />} />
      {/* From the emailed links, signed in or not. */}
      <Route path="/set-password" element={<SetPasswordPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />

      <Route path="*" element={<Authenticated user={user} loading={loading} />} />
    </Routes>
  )
}

function Authenticated({
  user,
  loading,
}: {
  user: ReturnType<typeof usePortalAuth>['user']
  loading: boolean
}) {
  if (loading) {
    return (
      <div className="login-wrap">
        <div className="skeleton" style={{ width: 220, height: 44 }} />
      </div>
    )
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    )
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/shipments" element={<ShipmentsPage />} />
        <Route path="/orders" element={<OrdersPage />} />
        <Route path="/invoices" element={<InvoicesPage />} />
        <Route path="/claims" element={<ClaimsPage />} />
        <Route path="/login" element={<Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  )
}
